export default __webpack_public_path__ + "static/media/umbrellas-mobile.f7518a19.jpg";